const sizeGuideOpenSelector = '[data-size-guide-open]';
const sizeGuideCloseSelector = '[data-size-guide-close]';

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const openButton = target.closest(sizeGuideOpenSelector);
  if (openButton instanceof HTMLButtonElement) {
    const dialogId = openButton.getAttribute('aria-controls');
    const dialog = dialogId ? document.getElementById(dialogId) : null;
    if (dialog instanceof HTMLDialogElement) {
      dialog.showModal();
    }
    return;
  }

  const closeButton = target.closest(sizeGuideCloseSelector);
  if (closeButton instanceof HTMLButtonElement) {
    closeButton.closest('dialog')?.close();
    return;
  }

  if (target instanceof HTMLDialogElement && target.matches('.pdp-size-guide-dialog')) {
    const bounds = target.getBoundingClientRect();
    const clickedInside =
      event.clientX >= bounds.left &&
      event.clientX <= bounds.right &&
      event.clientY >= bounds.top &&
      event.clientY <= bounds.bottom;

    if (!clickedInside) target.close();
  }
});
